var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9.934,
    viewBox: "0 0 10 9.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "refresh_FILL1_wght600_GRAD0_opsz24",
    d: "M143.488-809.284a4.79,4.79,0,0,1-3.518-1.449,4.79,4.79,0,0,1-1.449-3.518,4.79,4.79,0,0,1,1.449-3.518,4.79,4.79,0,0,1,3.518-1.449,4.939,4.939,0,0,1,2.061.442,4.618,4.618,0,0,1,1.668,1.276v-1.718h1.3v4.505h-4.514v-1.3h2.41a3.427,3.427,0,0,0-1.244-1.214,3.335,3.335,0,0,0-1.686-.444,3.293,3.293,0,0,0-2.419,1,3.293,3.293,0,0,0-1,2.419,3.293,3.293,0,0,0,1,2.419,3.293,3.293,0,0,0,2.419,1,3.319,3.319,0,0,0,1.957-.619,3.394,3.394,0,0,0,1.253-1.624h1.619a4.922,4.922,0,0,1-1.76,2.732A4.8,4.8,0,0,1,143.488-809.284Z",
    transform: "translate(-138.521 819.218)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a051b5b823182e29fd67148246860220.svg";
export { ForwardRef as ReactComponent };